import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { CONTACT, SERVICES, AREAS } from "@/data";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#161619] border-t border-white/10 text-gray-300 pt-16 pb-28 lg:pb-12 relative overflow-hidden">
      <div className="grain absolute inset-0 opacity-[0.04] pointer-events-none" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-40 bg-[#E63946]/10 blur-[120px] rounded-full pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src="/mjl-logo.jpeg" alt="MJL Maintenance & Locks Ltd" className="h-12 w-auto rounded-md ring-1 ring-white/10" />
          <p className="mt-4 text-sm text-gray-400 leading-relaxed">
            Trusted locksmith, property maintenance, security, joinery and clearance services
            across Buckinghamshire. Fully insured, fast response, free quotes.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a
              data-testid="footer-instagram"
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="MJL on Instagram"
              className="flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-gray-200 hover:bg-[#E63946] hover:border-[#E63946] hover:text-white transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              data-testid="footer-facebook"
              href={CONTACT.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="MJL on Facebook"
              className="flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-gray-200 hover:bg-[#E63946] hover:border-[#E63946] hover:text-white transition-colors"
            >
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-white">Services</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            {SERVICES.map((s) => (
              <li key={s.key}>{s.title}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-white">Areas Covered</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            {AREAS.slice(0, 7).map((a) => (
              <li key={a} className="flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5 text-[#E63946]" /> {a}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-white">Get in touch</h4>
          <ul className="space-y-3 text-sm text-gray-300">
            <li>
              <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 hover:text-[#E63946] transition-colors">
                <Phone className="w-4 h-4 text-[#E63946]" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-[#E63946] transition-colors break-all">
                <Mail className="w-4 h-4 text-[#E63946]" /> {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} MJL Maintenance &amp; Locks Ltd. All rights reserved. Locksmith
        &amp; Property Maintenance in Buckinghamshire.
      </div>
    </footer>
  );
};
